module.exports = require('./browser/algorithms.json')



//////////////////
// WEBPACK FOOTER
// ./~/browserify-sign/algos.js
// module id = 830
// module chunks = 10